import React from 'react'

type Props = {
  src: string
  title: string
  width: string
  padding?: string
  scale?: number
  imgFilter?: string
  hasError?: boolean
  isCorrect?: boolean
  onClick: Function | any
  onLabelClick?: Function | any
}
export const Image: React.FC<Props> = ({
  src,
  title,
  width,
  padding,
  scale = 1.2,
  imgFilter,
  hasError,
  isCorrect,
  onClick,
  onLabelClick,
}) => {
  return (
    <div
      className="overflow-hidden flex flex-col items-center justify-center w-full h-full"
      style={{ padding }}
      draggable={false}
    >
      <div
        className="imgBackground"
        onClick={onClick}
        style={{
          width,
          height: width,
          padding,
          transform: `scale(${scale})`,
          backgroundImage: `url(${src})`,
          backgroundPosition: '50% 50%',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          filter: imgFilter,
          border: hasError ? '35px solid red' : isCorrect ? '5px solid green' : 'none',
        }}
      />
      {/*<img className={'img'} src={src} alt={title} title={title} onClick={onClick} style={{ transform: 'scale(1.5)' }} draggable={false} />*/}
      {/*<img className={'img rounded'} src={src} alt={title} title={title} onClick={onClick} style={{ transform: 'scale(1.02)' }} draggable={false} />*/}
      {/*<img className={'img rounded'} alt={title} title={title} onClick={onClick} style={{ transform: 'scale(1.02)', backgroundImage: `${src}` }} draggable={false} />*/}
      {hasError && <div style={{ color: 'red', position: 'absolute', fontSize: '4rem' }}>chyba</div>}
      {title?.length > 0 && (
        <div
          className="absolute mt-32 card glass bg-white opacity-80 p-1 font-bold cursor-pointer"
          style={{
            backgroundColor: isCorrect ? 'green' : 'white',
            color: isCorrect ? 'white' : 'black',
          }}
          onClick={onLabelClick}
        >
          {title}
        </div>
      )}
    </div>
  )
}
